import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { ComplaintPathwayTypes, Const_ChiefComplaint, Const_DifferentialDiagnosis, Const_OrderSet, Const_Treatment, Const_Triage, DiseasePathwayTypes, pathwayType_SingleState, PathwayTypes, PathwayTypeToLabel } from '@app/pathway-shared';
import { DropDown_DefaultCaret } from '@app/styles/frontend/ui/consts';
import { SimpleListAdapter, TS_DropDown } from '@nu-art/thunderstorm-frontend';
import { useEffect, useState } from 'react';
const calculateAllowedTypes = (currentType) => {
    switch (currentType) {
        case Const_DifferentialDiagnosis: // 'differential-diagnosis'
        case Const_Treatment: // 'treatment'
            return [...DiseasePathwayTypes];
        case Const_ChiefComplaint: // 'chief-complaint'
        case Const_Triage: // 'triage'
            // order-set is a permitted migration target for complaint pathways
            return [...ComplaintPathwayTypes, Const_OrderSet];
        case pathwayType_SingleState:
            return [pathwayType_SingleState];
        case Const_OrderSet:
            return [Const_OrderSet];
        default:
            return [...PathwayTypes];
    }
};
export const Editor_PathwayType = (props) => {
    const [allowedTypes, setAllowedTypes] = useState([]);
    useEffect(() => {
        setAllowedTypes(calculateAllowedTypes(props.pathway.item.type));
    }, [props.pathway.item.type]);
    const adapter = SimpleListAdapter(allowedTypes, type => _jsx(_Fragment, { children: PathwayTypeToLabel[type.item] }));
    return _jsx(TS_DropDown, { adapter: adapter, disabled: !props.editMode, selected: props.pathway.item.type, caret: DropDown_DefaultCaret, onSelected: type => {
            props.pathway.set('type', type);
        } });
};
//# sourceMappingURL=Editor_PathwayType.js.map